import {closeSnackbar, useSnackbar} from 'notistack';
import CustomSnackbar from '../components/CustomSnackbar'; // путь поправь под себя

export const useShowSuccessSnackbar = () => {
    const { enqueueSnackbar } = useSnackbar();

    return () => {
        enqueueSnackbar('', {
            content: (key) => (
                <CustomSnackbar
                    id={key}
                    closeSnackbar={closeSnackbar}
                    sx={{
                        '& .SnackbarContainer-root': {
                            marginTop: '100px',
                        },
                    }}
                />
            ),
            anchorOrigin: {vertical: 'top', horizontal: 'right'},
            autoHideDuration: 2000,
        });
    };
};
